import React, { Fragment, useState } from 'react'
import { BorderColor, Menu } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ENDPOINT, Routes } from '../../constants'
import { useAuth } from '../../contexts/AuthContext'
import { FeaturedProps } from '../../types/featured'
import Button from '../Button'
import Modal from '../Modal'
import { FetchApi } from '../../api/fetch'

type Props = {
   data: FeaturedProps;
   getFeatured: () => void
}


function FeaturedCard({ data, getFeatured }: Props) {
   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()
   const {  getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = () => {
      setDeleteInitiated(true)
   }

   const deleteFeatured = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()
      try {
         let response: any = await FetchApi({
            endpoint:`${ENDPOINT.BASE_ENDPOINT}/featured_project/${data?.id}`, 
            method: "DELETE",
            JWT:userJWT
         })
         response = await response.json()

         if (response) {
            getFeatured();
         }
         if (!response.success) {
            toast.error(response.message)
         }
         setIsLoadingOverlayDisplay(false)

      } catch (error) {
         console.log('something went wrong');
      }
   }
   return (
      <Fragment>

         <div className="bg-gray-80 flex items-center justify-between p-4 my-4 rounded-xl">
            <div className='flex items-center'>
               <div>
                  <Menu className="h-8 text-gray-50 mr-3" />
               </div>
               <div className="feat-desc flex items-center">
                  <div className="mr-3 w-20">
                     <img src={data.thumbnailUrl} alt='thumbnail' className="rounded-full w-20 h-20" />
                  </div>
                  <div className='w-10/12'>
                     <h3 className="mb-1.5 font-medium">{data.name} - <a href={data.projectUrl} className="text-blue text-sm font-light">{data.projectUrl}</a></h3>
                     <p className="font-extralight text-sm">{data.description} <br /> Created: 01 Feb. 2023,  08:00 UTC</p>
                  </div>
               </div>
            </div>

            <div className="flex">
               <Link to={{ pathname: `${Routes.MANAGE_FEATURED}/${data?.id}`, state: data }} >
                  <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm">
                     <BorderColor className="h-4 text-gray-50" />
                     Edit
                  </button>
               </Link>
               <button className="border border-gray-50 py-1 px-3 rounded-xl" onClick={onDelete}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21.07 5.23c-1.61-.16-3.22-.28-4.84-.37v-.01l-.22-1.3c-.15-.92-.37-2.3-2.71-2.3h-2.62c-2.33 0-2.55 1.32-2.71 2.29l-.21 1.28c-.93.06-1.86.12-2.79.21l-2.04.2c-.42.04-.72.41-.68.82.04.41.4.71.82.67l2.04-.2c5.24-.52 10.52-.32 15.82.21h.08c.38 0 .71-.29.75-.68a.766.766 0 0 0-.69-.82ZM19.23 8.14c-.24-.25-.57-.39-.91-.39H5.68c-.34 0-.68.14-.91.39-.23.25-.36.59-.34.94l.62 10.26c.11 1.52.25 3.42 3.74 3.42h6.42c3.49 0 3.63-1.89 3.74-3.42l.62-10.25c.02-.36-.11-.7-.34-.95Zm-5.57 9.61h-3.33c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.33c.41 0 .75.34.75.75s-.34.75-.75.75Zm.84-4h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75Z" fill="#667085"></path></svg>
               </button>
            </div>
         </div>

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete featured project'>
            <div className='flex justify-center gap-3 mt-8'>
               <div className=" text-center">
                  <button onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
                  onClick={deleteFeatured}
               >
                  Yes
               </Button>
            </div>
         </Modal>

      </Fragment>
   )
}

export default FeaturedCard